import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TierPracticeFilled icon
 *
 * @category Tier
 */
const TierPracticeFilled = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M9.429 10.139A6.78 6.78 0 0 1 16 5.043a6.78 6.78 0 0 1 6.783 6.783c0 .28-.02.558-.054.823l-.001.012a6.73 6.73 0 0 1-2.337 4.327c-.514.436-1.257.126-1.535-.487a8.8 8.8 0 0 0-2.154-2.923 8.78 8.78 0 0 0-6.16-2.27c-.674.018-1.28-.516-1.113-1.169m14.643 5.358c.278-.613 1.021-.922 1.534-.487A6.75 6.75 0 0 1 28 20.174a6.785 6.785 0 0 1-6.783 6.782 6.7 6.7 0 0 1-4.521-1.737l-.254-.24a6.77 6.77 0 0 1-1.794-3.118c-.168-.653.437-1.187 1.111-1.169q.12.004.241.004c1 0 1.989-.166 2.906-.504a8.84 8.84 0 0 0 5.166-4.695M8.597 13.765a6.3 6.3 0 0 1 2.186-.374 6.8 6.8 0 0 1 2.603.518c.58.243.684.978.345 1.509a8.74 8.74 0 0 0-1.312 3.659 8.8 8.8 0 0 0 1.319 5.851c.339.53.236 1.263-.344 1.506A6.785 6.785 0 0 1 4 20.174a6.76 6.76 0 0 1 4.572-6.4l.013-.005z"
          clip-rule="evenodd"
        />
      </svg>
    );
  }
);

TierPracticeFilled.displayName = 'TierPracticeFilled';

export { TierPracticeFilled };
